import { useContext, useMemo, useState } from "react";
import { LiffStubContext } from "../stub/liffStub";
import {
  AppBar,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Toolbar,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import styled from "styled-components";
import PersonIcon from "@mui/icons-material/Person";
import HomeIcon from "@mui/icons-material/Home";
import HandymanIcon from "@mui/icons-material/Handyman";
import ChecklistIcon from '@mui/icons-material/Checklist';  

type DrawerItem = {
  name: string;
  url: string;
  icon: JSX.Element;
  new: boolean;
  ownerOnly: boolean;
  adminOnly: boolean;
  rootOnly: boolean;
};

const Header = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const icon = <PersonIcon />

  const displayName = "管理者ユーザー"

  const drawerItemList = useMemo(() => {
    const drawerItems = [
      {
        name: "管理者メニュー",
        url: "/admin/AdminMenu",
        icon: <HandymanIcon sx={{ color: "white" }} />,
        new: false,
        ownerOnly: true,
        adminOnly: false,
        rootOnly: false,
      } as DrawerItem, 
      {
        name: "予約管理",
        url: "/admin/confirm",
        icon: <ChecklistIcon sx={{ color: "white" }} />,
        new: false,
        ownerOnly: true,
        adminOnly: false,
        rootOnly: false,
      } as DrawerItem, 
      {
        name: "キャンセル管理",
        url: "/admin/CancelManagement",
        icon: <ChecklistIcon sx={{ color: "white" }} />,
        new: false,
        ownerOnly: true,
        adminOnly: false,
        rootOnly: false,
      } as DrawerItem,
    ];
    const list = drawerItems
      .map((item, index) => (
        <ListItem
          key={"drawerItem-" + index}
          sx={{ width: "220px", backgroundColor: "none", cursor: "pointer" }}
          onClick={() => {
            window.location.href = item.url;
          }}
        >
          <ListItemIcon>{item.icon}</ListItemIcon>
          <ListItemText primary={item.name} />
        </ListItem>
      ));
    return (
      <List sx={{ height: "100%", backgroundColor: "black", color: "white" }}>
        {list}
      </List>
    );
  }, []);

  return (
    <HeaderStyle>
      <AppBar
        position="fixed"
        style={{
          textAlign: "center",
          backgroundColor: "white",
        }}
      >
        <Toolbar
          sx={{
            fontSize: "10px",
            height: "70px",
            justifyContent: "space-between",
          }}
        >
          <IconButton
            size="large"
            edge="start"
            aria-label="menu"
            sx={{ mr: 2, color: "black" }}
            onClick={() => {
              setDrawerOpen(true);
            }}
          >
            <MenuIcon />
          </IconButton>
          <div
            className="logo"
            onClick={() => {
              window.location.href = "/admin/AdminMenu";
            }}
          ></div>
          <div className="line_info">
            <div className="line_icon">{icon}</div>
            <div className="line_name">{displayName}</div>
          </div>
        </Toolbar>
      </AppBar>
      <Drawer
        container={
          typeof window !== undefined ? () => window.document.body : undefined
        }
        variant="temporary"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      >
        {drawerItemList}
      </Drawer>
    </HeaderStyle>
  );
};

const HeaderStyle = styled.div`
  margin-bottom: 20px;
  .line_info {
    text-align: center;
    max-width: 110px;
    height: 60px;
    color: black;
    .line_name {
      margin: auto;
      text-align: center;
      max-width: 100px;
      font-size: 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .logo {
    cursor: pointer;
    background: no-repeat;
    background-image: url("https://d1ffgoh8hssh4w.cloudfront.net/assets/1-ahead-white.jpg");
    background-size: 70px;
    width: 70px;
    height: 70px;
  }
`;

export default Header;
